import { Point, Rect, Scale, TranslateScreen2To1 } from "../../.././MyHelpers";
import { SpinAndHoldCommonConfiguration } from "../../../api";
import { Resourceful2 } from "../../../ResourceManager/Resourceful";
import { SpinAndHoldBonus_2Screen } from "../SpinAndHold/SpinAndHoldBonus_2Screen";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";

export class BigSymbolSpinAndHoldBonus_2Screen extends SpinAndHoldBonus_2Screen implements Resourceful2 {
	
	protected override BonusName(): string
	{
		return "BigSymbolSpinAndHold";
	}

	public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
    }
    
    protected override DesinationComet():Point
	{
		 let destination: Point = TranslateScreen2To1(new Rect(Scale.X(-430) ,Scale.Y(340) ,Scale.W(1920) ,Scale.H(1080))).Center();
		return destination
	}
}


export interface IBigSymbolSpinAndHoldBonusFactory_2Screen
{
	CreateBigSymbolSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHoldBonus_2Screen;
}

export class BigSymbolSpinAndHoldBonusFactory_2Screen implements IBigSymbolSpinAndHoldBonusFactory_2Screen
{
	public CreateBigSymbolSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): BigSymbolSpinAndHoldBonus_2Screen
	{
		return new BigSymbolSpinAndHoldBonus_2Screen(gameName, params, config);
	}
}
